import React, { Component } from "react";
import moment from "moment/moment";
import CardEmpty from "Utils/Cards/CardEmpty";
import { PrintContainer, actions as printActions } from "Utils/Print";
import "react-step-progress-bar/styles.css";
import { DatosBoleta } from "./DatosBoleta";
import "./BoletaTraslado.css";

export default class BoletaTraslado extends Component {
    state = {
        traslado_id: null,
    };

    componentWillMount() {
        this.setState({ traslado_id: this.props.match.params.id });
    }

    imprimirBoleta = (event) => {
        printActions.print("boleta-traslado");
    };

    render() {
        return (
            <div>
                <CardEmpty>
                    <PrintContainer name="boleta-traslado">
                        <DatosBoleta trasladoId={this.state.traslado_id} />
                    </PrintContainer>
                </CardEmpty>
                <div className="mb-4 col-12 p-0">
                    <div className="row mb-5">
                        <div className="col-12 row">
                            <div className="col-12 d-flex justify-content-center mt-5">
                                <div className="col-9 buttons-box">
                                    <button
                                        className="btn btn-outline-dark mr-5"
                                        onClick={() =>
                                            this.props.history.goBack()
                                        }
                                    >
                                        CERRAR
                                    </button>
                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                        onClick={this.imprimirBoleta}
                                    >
                                        IMPRIMIR
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
